var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemBrainIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,0A3.23,3.23,0,0,0,14.8,3.18V24.81a3.21,3.21,0,0,0,6.38.44.8.8,0,0,1,.73-.66,5.43,5.43,0,0,0,4.94-5.18A4.83,4.83,0,0,0,22,14.8a.8.8,0,0,1,0-1.6,6.53,6.53,0,0,1,3.76,1.17l0,0A5.22,5.22,0,0,0,28,10a5.53,5.53,0,0,0-5.46-5.46H22a.8.8,0,0,1-.8-.8V3.18A3.23,3.23,0,0,0,18,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.09,24.59a.8.8,0,0,1,.73.66,3.21,3.21,0,0,0,6.38-.44V3.18a3.19,3.19,0,0,0-6.37,0A3.49,3.49,0,0,0,8,5.69.8.8,0,0,1,8,6.82a.77.77,0,0,1-.56.24.8.8,0,0,1-.57-.24A5.35,5.35,0,0,1,5.44,4.55,5.54,5.54,0,0,0,0,10a4.08,4.08,0,0,0,0,.61l0,.22c0,.12,0,.24.07.35a2.81,2.81,0,0,0,.08.31l.06.2a5.55,5.55,0,0,0,1.24,2,3.88,3.88,0,0,0,.73.61.77.77,0,0,1,.18.18,5.41,5.41,0,0,0,3,1,.8.8,0,0,1,0,1.6A6.9,6.9,0,0,1,2,16.14a5.51,5.51,0,0,0-.88,3A5.43,5.43,0,0,0,6.09,24.59Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemBrainIconFill);
export default __webpack_public_path__ + "static/media/item_brain_icon_fill.adfac60f8450b59f9cdf4666203eebb5.svg";
export { ForwardRef as ReactComponent };